<template>
  <div class="card">
    <div class="card-content">
      <div class="content">
        <div class="is-flex is-align-content-center is-justify-content-center">
          <iframe
            :src="`https://player.vimeo.com/video/${video}`"
            width="640"
            height="480"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          />
        </div>

        <!-- For categorizing muscle groups, only by Josh and I -->
        <div v-if="user.email==='spencer.speas@gmail.com' || 'jw0156@uah.edu'" class="mb-4">
          <b-field label="Muscle Group" label-position="on-border">
            <b-select v-model="selectedMuscleGroup" placeholder="Select a muscle group" multiple expanded>
              <option 
                v-for="group in muscleGroups" :key="group.value" 
                :value="group.value"
                >{{ group.label }}
              </option>
            </b-select>
            <p class="control">
              <b-button @click="saveMuscleGroup()" :disabled="selectedMuscleGroup.length === 0" class="button is-success">
                <strong>Save</strong>
              </b-button>
            </p>
          </b-field>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/main';
// import firebase from 'firebase/app';
// import 'firebase/firestore';
import { mapState } from 'vuex';

export default {
  name: 'videoPlayer',
  props: {
    video: String,
  },
  methods: {
    saveMuscleGroup() {
      db.collection('videos').doc(this.video).update({
        muscle_group_tags: this.selectedMuscleGroup
      }, { merge: true })
        .then(
          this.$buefy.toast.open({
          type: 'is-success',
          message: 'Success'
        }))
        .catch(
          this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Failed. Try again.'
        }))
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  data() {
    return {
      selectedMuscleGroup: [],
      muscleGroups: [
        // {
        //   label: 'All',
        //   value: null
        // },
        {
          label: 'Lumbar',
          value: 'lumbar'
        },
        {
          label: 'Shoulder',
          value: 'shoulder'
        },
        {
          label: 'Hip',
          value: 'hip'
        },
        {
          label: 'Knee',
          value: 'knee'
        },
        {
          label: 'Hand & Wrist',
          value: 'handAndWrist'
        },
        {
          label: 'Foot & Ankle',
          value: 'footAndAnkle'
        }
      ]
    }
  }
}
</script>